<template>
  <div class="flex items-center justify-center h-full bg-app">
    <div class="w-full max-w-md bg-white px-6 py-6 rounded-lg shadow-lg">
      <img src="https://accesos.rgcc-dev.es/logo-rgcc.svg"
        class="mx-auto my-6 brand"
        alt="Real Grupo Cultural Covadonga - Control de Accesos"
        title="Real Grupo Cultural Covadonga - Control de Accesos"
      />
      <h2 class="text-2xl font-bold mb-2 font-sans">Se ha producido un error</h2>
      <p class="mb-2">Lo sentimos, pero no se ha encontrado la página solicitada.</p>
      <p>
        Regrese al inicio y vuelva a intentarlo. Si el problema persiste escríbanos a la siguiente dirección de correo electrónico
        <a href="mailto:info@rgcc.es" class="text-secondary underline hover:text-secondary-800">info@rgcc.es</a>
        y trataremos de ayudarle a la mayor brevedad posible.
      </p>
      <div class="flex justify-end mt-6">
        <router-link to="/">
          <button class="px-6 py-3 bg-secondary text-white rounded hover:bg-secondary-600 font-bold">Regresar al inicio</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>
